import { Component } from '@angular/core';

@Component({
  selector: 'app-new-property-list',
  templateUrl: './new-property-list.component.html',
  styleUrls: ['./new-property-list.component.css']
})
export class NewPropertyListComponent {

}
